export const VERSIONS_DROPDOWN_OPTIONS = [{ id: '', name: 'V1' },{ id: '_v2', name: 'V2' } ];